// Order module internationalization - English
export default {
  // Mode switching
  modes: {
    business: 'Business',
    tracking: 'Tracking',
    warehouse: 'Warehouse'
  },

  // Loading messages
  loading: {
    trackingInfo: 'Loading tracking information...',
    businessNodes: 'Loading business nodes...'
  },

  // Error messages
  error: {
    loadTrackingFailed: 'Failed to load tracking information',
    loadBusinessStatusFailed: 'Failed to load business status'
  },

  // Business nodes (SOP)
  businessNodes: {
    remark: 'Remark: ',
    empty: 'No business nodes',
    legend: {
      done: 'Completed',
      doing: 'In Progress',
      warn: 'Exception',
      wait: 'Not Started'
    }
  },

  // Tracking nodes
  trackingNodes: {
    // Status legend
    legend: {
      manual: 'Manual',
      thirdParty: '3rd Party',
      pending: 'Pending'
    },

    // Node information
    info: {
      quantity: 'Quantity',
      plannedBerth: 'Planned Berth',
      plannedUnberth: 'Planned Unberth'
    }
  }
}
